<template>
  <router-view name="campaign" v-bind:key="$route.path"></router-view>
</template>

<script>
export default {
  name: "Campaign",
};
</script>
